import { api } from "./api";
import { setPermissions } from "./permissions";
import { setTranslation } from "./translation";
import { setUser } from "./user";

export function initData () {
    return new Promise<void>((resolve) => {
        api().silent().get('/init-data').then(({ data }) => {
            setTranslation(data.translation);
            setUser(data.user);
            setPermissions(data.permissions);
            resolve()
        }).catch(error => {
            console.log("Init Data : ", error);
            resolve()
        })
    })
}
